// Custom Events
export const EVENTS_SHOW_FOOTER = 'show-footer';
export const EVENTS_NEW_REQUEST = 'modal-new-request';
export const EVENTS_OPEN_NEW_CERTIFIED_FILE_MODAL = 'open-new-certified-file-modal';
export const EVENTS_CLOSE_MODAL = 'close-modal';
export const OPEN_NEW_REQUEST_MODAL = 'open-new-request-modal';
export const RESPONSE_CONFIRM_LEAVE_MODAL = 'response-confirm-leave-modal';
export const SHOW_SENDBOARD_LEAVE_MODAL = 'show-sendboard-leave-modal';
export const HIDE_SIDE_TOP_MENUS = 'hide-side-top-menus';
export const HIDE_TRIAL_BAR = 'hide-trial-bar';
export const SHOW_SIDE_TOP_MENUS = 'show-side-top-menus';
export const EVENTS_SUCCESS = 'success';
export const EVENTS_WARNING = 'warning';
export const EVENTS_ERROR = 'error';
export const EVENTS_NOTIFICATION_ERROR = 'notification-error';
export const EVENTS_INFO = 'info';
export const HIDE_FIXED_NOTIFICATIONS_WRAPPER = 'hide-fixed-notifications-wrapper';
export const EVENTS_OPEN_CERTIFIED_EMAIL_MODAL = 'modal-certified-email';
export const EVENTS_NEW_TEMPLATE_CERTIFIED = 'new-template-certified';
export const OPEN_DASHBOARD_NEW_REQUEST_MODAL = 'open_dashboard_new_request_modal';
export const DASHBOARD_NEW_REQUEST_MODAL_CLOSED = 'dashboard_new_request_modal_closed';
export const EVENTS_OPEN_CERTIFIED_SMS_MODAL = 'modal-certified-sms';
